import React from 'react';
import styles from './Button.module.scss';

type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'default' | 'strong';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  fullWidth?: boolean;
  isLoading?: boolean;
  hasArrow?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'default',
  size = 'medium',
  disabled = false,
  fullWidth = false,
  isLoading = false,
  hasArrow = false,
  type = 'button',
  className = '',
}) => {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : '',
    isLoading ? styles.loading : '',
    hasArrow ? styles.withArrow : '',
    className,
  ]
    .join(' ')
    .trim();

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      <span className={styles.content}>{isLoading ? '...' : children}</span>
      {hasArrow && !isLoading && (
        <span className={styles.arrowWrapper}>
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 24 24"
          >
            <g id="arrow_right_alt">
              <mask
                height="24"
                id="mask0_7171_26588"
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
                width="24"
                x="0"
                y="0"
              >
                <rect fill="#111111" height="24" id="Bounding box" width="24" />
              </mask>
              <g mask="url(#mask0_7171_26588)">
                <path
                  d="M13.8462 17.6537L12.7923 16.5692L16.6115 12.75H4.5V11.25H16.6115L12.7923 7.43075L13.8462 6.34625L19.5 12L13.8462 17.6537Z"
                  fill="#111111"
                  id="arrow_right_alt_2"
                />
              </g>
            </g>
          </svg>
        </span>
      )}
    </button>
  );
}; 